import cx from 'clsx';
import React from 'react';
import { useDropzone } from 'react-dropzone';
import { useController } from 'react-hook-form';

import { ReactComponent as PhotoIcon } from '@assets/svg/ic-photo.svg';
import { ReactComponent as RemoveIcon } from '@assets/svg/ic-remove.svg';

import EditorForm from '@components/form/EditorForm/EditorForm';
import Input from '@components/uikit/Input/Input';
import Select from '@components/uikit/Select/Select';

import { FILE_SIZE_LIMIT } from '@constants/dropzoneFileLimits';

import { showToast } from '@helpers/showToast';

import useTranslation from '@hooks/useTranslation';

import { SENSOR_REPLACE_FIELDS } from '../constants/schemaSensorReplace';
import style from './style.module.scss';

const StepSensorReplaceFormInfo = ({ control, reasonValueId }) => {
  const { t } = useTranslation();

  const {
    field: { value: photoValue, onChange: photoValueChange },
    fieldState: { error: photoValueError },
  } = useController({ control, name: SENSOR_REPLACE_FIELDS.NEW_PHOTO });

  const reasonsList = [
    {
      id: 1,
      name: t('Waites requested it via a "replace sensor" Action Item'),
    },
    {
      id: 2,
      name: t('Physical damage to the sensor (e.g. sensor was severed/ destroyed)'),
    },
    {
      id: 3,
      name: t('Other'),
    },
  ];

  const { getRootProps, getInputProps, open } = useDropzone({
    maxFiles: 1,
    accept: { 'image/*': [] },
    onDrop: (files) => {
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = () => {
        photoValueChange(reader.result);
      };
      reader.onerror = (error) => console.log(error);
    },

    validator: (file) =>
      file.size > FILE_SIZE_LIMIT
        ? showToast({ variant: 'success', message: t('The file is too large.') })
        : null,
    noClick: true,
    noKeyboard: true,
  });

  return (
    <div className={style.stepFormInfo}>
      <div className={style.twoParts}>
        <Select
          name={SENSOR_REPLACE_FIELDS.REASON}
          control={control}
          label={t('Select a reason')}
          options={reasonsList}
          required
        />
        <Input
          name={SENSOR_REPLACE_FIELDS.NEW_HEX}
          control={control}
          label={t('Enter a new sensor hex code')}
          placeholder={t('Enter code')}
          required
        />
      </div>
      <div className={cx(style.otherBlock, { [style.twoParts]: +reasonValueId === 3 })}>
        {+reasonValueId === 3 && (
          <EditorForm
            name={SENSOR_REPLACE_FIELDS.REASON_DESCRIPTION}
            control={control}
            label="Description a reason"
            required
          />
        )}
        <div className={style.photoBlock}>
          <label className={cx(style.fieldLabel, style.required)}>{t('New sensor photo')}</label>
          {photoValue ? (
            <div className={style.imageWrapper}>
              <img src={photoValue} className={style.photoBlockImage} alt="img" />
              <RemoveIcon className={style.removeIcon} onClick={() => photoValueChange('')} />
            </div>
          ) : (
            <>
              <div {...getRootProps()} className={style.attachmentsField} onClick={open}>
                <input {...getInputProps()} />
                <PhotoIcon />
                <span className={style.attachmentsFieldLink}>{t('Add photo')}</span>
              </div>
              <div className={style.helperText}>{photoValueError && t(photoValueError?.message)}</div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default StepSensorReplaceFormInfo;
